import { useCallback, useEffect, useMemo, useRef, useState } from 'preact/hooks'

type UseCounterReturn = {
  counter: number
  reset: () => void
}

export function useCounter(initialValue: number): UseCounterReturn {
  const [counter, setCounter] = useState<number>(initialValue)
  const intervalRef = useRef<NodeJS.Timeout | null>(null)

  const clear = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current)
      intervalRef.current = null
    }
  }

  const start = useCallback(() => {
    clear()

    intervalRef.current = setInterval(() => {
      setCounter((prev) => {
        if (prev <= 1) {
          clear()
          return 0
        }
        return prev - 1
      })
    }, 1000)
  }, [])

  const reset = useCallback(() => {
    setCounter(initialValue)
    start()
  }, [initialValue, start])

  useEffect(() => {
    start()
    return clear
  }, [start])

  return useMemo(() => ({
    counter,
    reset,
  }), [counter, reset])
}
